export default defineNuxtPlugin((nuxtApp) => {
  const {
    public: { hubspot },
  } = useRuntimeConfig()

  nuxtApp.hook('page:finish', () => {
    if (!hubspot.id) {
      return
    }

    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.id = 'hs-script-loader'
    script.src = `//js-eu1.hs-scripts.com/${String(hubspot.id)}.js`
    document.body.appendChild(script)
  })
})
